import React, { useState, useEffect, useRef } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { OverlayView } from "@react-google-maps/api"; 
import { FaMapMarkerAlt } from "react-icons/fa";

const MapComponent = ({ lat, lng }) => {
  const [position, setPosition] = useState(null); // Inicializar la posición como `null`
  const [mapLoaded, setMapLoaded] = useState(false);
  const mapRef = useRef();

  // Carga de la API de Google Maps
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyC8ecA7hFLV7REGMXlzLiZOF8XmkzNWhzY", // Asegúrate de que esta clave sea válida
  });

  // 1. Cargar las coordenadas desde `localStorage` o usar las props al cargar el componente
  useEffect(() => {
    const savedPosition = localStorage.getItem("mapPosition");
    if (savedPosition) {
      const parsedPosition = JSON.parse(savedPosition);
      setPosition(parsedPosition); // Establecer la posición desde el `localStorage`
    } else {
      setPosition({ lat, lng }); // Establecer las coordenadas iniciales si no hay datos en el `localStorage`
    }
  }, []); // Este `useEffect` se ejecuta solo una vez al cargar el componente (sin depender de las props `lat` y `lng`)

  // 2. Actualizar las coordenadas si las props (`lat`, `lng`) cambian
  useEffect(() => {
    if (lat && lng) {
      setPosition({ lat, lng }); // Actualizar `position` cuando cambian las props
    }
  }, [lat, lng]); // Solo se ejecuta cuando las coordenadas pasadas como props cambian

  // 3. Guardar las coordenadas en `localStorage` cuando cambian
  useEffect(() => {
    if (position) {
      localStorage.setItem("mapPosition", JSON.stringify(position)); // Guardar en `localStorage` cada vez que `position` cambie
    }
  }, [position]); // Solo se ejecuta cuando la posición cambia

  // 4. Manejo de carga y error de la API
  if (loadError) {
    return <div>Error al cargar el mapa</div>;
  }

  if (!isLoaded || position === null) {
    return <div>Cargando mapa...</div>; // Esperar hasta que se cargue el mapa y la posición esté lista
  }

  // Manejamos cuando el mapa está completamente cargado
  const onMapLoad = (map) => {
    mapRef.current = map;
    setMapLoaded(true); // Cuando el mapa se haya cargado, actualizamos el estado
    mapRef.current.panTo(position); // Aseguramos que el mapa se centre en la posición
    console.log("Mapa cargado y centrado en:", position);
  };

  // Función para manejar el clic en el marcador
  const handleMarkerClick = () => {
    const url = `https://www.google.com/maps?q=${position.lat},${position.lng}`;
    console.log("Abriendo Google Maps en: ", url); // Añadido para debug
    window.open(url, "_blank"); // Abrir Google Maps en una nueva ventana
  };

 // Crear un componente OverlayView para el ícono
 const IconOverlay = () => (
  <OverlayView
    position={position}
    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}  // Esto asegura que el ícono sea clickeable
  >
    <div className="marker-icon-container" onClick={handleMarkerClick}>
          <FontAwesomeIcon
            className="detail-room maps"
            icon={faMapMarkerAlt}
          />
    </div>
  </OverlayView>
);


return (
  <div className="map-component">
  
    <div className="map-header">
      <FaMapMarkerAlt className="map-icon" onClick={handleMarkerClick} />
      <h3 className="heading">¿Dónde se encuentra ubicado el espacio para tu evento?</h3>
    </div>

    <div className="my-custom-map-container">
      <GoogleMap
        mapContainerClassName="map-container"  
        center={position}
        zoom={18}
        onLoad={onMapLoad}
      >
      
        {/* OverlayView con el ícono que permanece fijo en el mapa */}
        {position && mapLoaded && (
          <OverlayView
            position={position}
            mapPaneName={OverlayView.OVERLAY_LAYER}
          >
            <IconOverlay />
          </OverlayView>
        )}
      
      </GoogleMap>
    </div>
  </div>
  );
};

export default MapComponent;


// Esto inicial 
// import React, { useState, useEffect, useRef } from "react";
// import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

// const MapComponent = ({ lat, lng }) => {
//   const [position, setPosition] = useState({ lat, lng });
//   const [mapLoaded, setMapLoaded] = useState(false);
//   const mapRef = useRef();

//   // Carga de la API de Google Maps
//   const { isLoaded, loadError } = useJsApiLoader({
//     googleMapsApiKey: "AIzaSyC8ecA7hFLV7REGMXlzLiZOF8XmkzNWhzY", // Asegúrate de que esta clave sea válida
//   });

//   // Mantener la posición cuando se refresca la página
//   useEffect(() => {
//     const savedPosition = localStorage.getItem("mapPosition");
//     if (savedPosition) {
//       const parsedPosition = JSON.parse(savedPosition);
//       setPosition(parsedPosition);
//     } else {
//       setPosition({ lat, lng });
//     }
//   }, []); // Solo se ejecuta una vez al cargar el componente

//   // Guardar las nuevas coordenadas en localStorage cada vez que cambian
//   useEffect(() => {
//     if (position) {
//       localStorage.setItem("mapPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Actualizar la posición si cambian las props (coordenadas)
//   useEffect(() => {
//     if (lat && lng) {
//       setPosition({ lat, lng });
//     }
//   }, [lat, lng]);

//   // Manejo de carga y error de la API
//   if (loadError) {
//     return <div>Error al cargar el mapa</div>;
//   }

//   if (!isLoaded) {
//     return <div>Cargando mapa...</div>;
//   }

//   // Manejamos cuando el mapa está completamente cargado
//   const onMapLoad = (map) => {
//     mapRef.current = map;
//     setMapLoaded(true); // Cuando el mapa se haya cargado, actualizamos el estado
//     mapRef.current.panTo(position); // Aseguramos que el mapa se centre en la posición
//     console.log("Mapa cargado y centrado en:", position);
//   };

//   return (
//     <GoogleMap
//       mapContainerStyle={{ width: "100%", height: "700px" }}
//       center={position} // Establece el centro en la posición
//       zoom={17} // Aumentamos el zoom para acercarnos más
//       onLoad={onMapLoad}
//     >
//       {/* Solo renderizamos los marcadores cuando el mapa esté completamente cargado */}
//       {mapLoaded && (
//         <>
//           {/* Marcador con un icono básico */}
//           <Marker
//             position={position}
//             key={`marker-${position.lat},${position.lng}`} // Asegura que el marcador se renderice correctamente con un key único
//             icon={{
//               path: window.google.maps.SymbolPath.CIRCLE,
//               scale: 17,
//               fillColor: "red",
//               fillOpacity: 1,
//               strokeColor: "white",
//               strokeWeight: 3,
//             }}
//             label="Aquí"
//             onLoad={() => console.log("Marcador cargado en:", position)}
//           />

//           {/* Otro marcador con el ícono estándar */}
//           <Marker
//             position={position}
//             key={`standardMarker-${position.lat},${position.lng}`} // Otro key único para el marcador
//             icon={{
//               url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png", // Ícono rojo básico
//               scaledSize: new window.google.maps.Size(40, 40), // Escalamos el icono
//             }}
//             label="Marcador 2"
//             onLoad={() => console.log("Marcador básico cargado en:", position)}
//           />
//         </>
//       )}
//     </GoogleMap>
//   );
// };

// export default MapComponent;

// import React, { useReducer, useEffect, useRef, useState } from "react";
// import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

// // Reducer para manejar la actualización de la posición del mapa
// const positionReducer = (state, action) => {
//   switch (action.type) {
//     case 'SET_POSITION':
//       return { lat: action.payload.lat, lng: action.payload.lng };
//     case 'LOAD_FROM_LOCAL_STORAGE':
//       return { lat: action.payload.lat, lng: action.payload.lng };
//     default:
//       return state;
//   }
// };

// const MapComponent = ({ lat, lng }) => {
//   const [position, dispatch] = useReducer(positionReducer, { lat, lng });
//   const [mapLoaded, setMapLoaded] = useState(false);
//   const mapRef = useRef();

//   // Carga de la API de Google Maps
//   const { isLoaded, loadError } = useJsApiLoader({
//     googleMapsApiKey: "AIzaSyC8ecA7hFLV7REGMXlzLiZOF8XmkzNWhzY", // Asegúrate de que esta clave sea válida
//   });

//   // Mantener la posición cuando se refresca la página
//   useEffect(() => {
//     const savedPosition = localStorage.getItem("mapPosition");
//     if (savedPosition) {
//       const parsedPosition = JSON.parse(savedPosition);
//       dispatch({ type: 'LOAD_FROM_LOCAL_STORAGE', payload: parsedPosition });
//     } else {
//       dispatch({ type: 'SET_POSITION', payload: { lat, lng } });
//     }
//   }, [lat, lng]); // Dependemos de las coordenadas pasadas como props

//   // Guardar las nuevas coordenadas en localStorage cada vez que cambian
//   useEffect(() => {
//     if (position) {
//       localStorage.setItem("mapPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Manejo de carga y error de la API
//   if (loadError) {
//     return <div>Error al cargar el mapa</div>;
//   }

//   if (!isLoaded) {
//     return <div>Cargando mapa...</div>;
//   }

//   // Manejamos cuando el mapa está completamente cargado
//   const onMapLoad = (map) => {
//     mapRef.current = map;
//     setMapLoaded(true); // Cuando el mapa se haya cargado, actualizamos el estado
//     mapRef.current.panTo(position); // Aseguramos que el mapa se centre en la posición
//     console.log("Mapa cargado y centrado en:", position);
//   };

//   return (
//     <GoogleMap
//       mapContainerStyle={{ width: "100%", height: "700px" }}
//       center={position} // Establece el centro en la posición
//       zoom={17} // Aumentamos el zoom para acercarnos más
//       onLoad={onMapLoad}
//     >
//       {/* Solo renderizamos los marcadores cuando el mapa esté completamente cargado */}
//       {mapLoaded && (
//         <Marker
//           position={position}
//           key={`marker-${position.lat},${position.lng}`} // Asegura que el marcador se renderice correctamente con un key único
//           icon={{
//             path: window.google.maps.SymbolPath.CIRCLE,
//             scale: 17,
//             fillColor: "red",
//             fillOpacity: 1,
//             strokeColor: "white",
//             strokeWeight: 3,
//           }}
//           label="Aquí"
//           onLoad={() => console.log("Marcador cargado en:", position)}
//         />
//       )}
//     </GoogleMap>
//   );
// };

// export default MapComponent;

// import React, { useState, useEffect, useRef } from "react";
// import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

// const MapComponent = ({ lat, lng }) => {
//   const [position, setPosition] = useState(null); // Inicializar la posición como `null`
//   const [mapLoaded, setMapLoaded] = useState(false);
//   const mapRef = useRef();

//   // Carga de la API de Google Maps
//   const { isLoaded, loadError } = useJsApiLoader({
//     googleMapsApiKey: "AIzaSyC8ecA7hFLV7REGMXlzLiZOF8XmkzNWhzY", // Asegúrate de que esta clave sea válida
//   });

//   // 1. Cargar las coordenadas desde `localStorage` o usar las props al cargar el componente
//   useEffect(() => {
//     const savedPosition = localStorage.getItem("mapPosition");
//     if (savedPosition) {
//       const parsedPosition = JSON.parse(savedPosition);
//       setPosition(parsedPosition); // Establecer la posición desde el `localStorage`
//     } else {
//       setPosition({ lat, lng }); // Establecer las coordenadas iniciales si no hay datos en el `localStorage`
//     }
//   }, [lat, lng]); // Dependemos de las coordenadas pasadas como props para recargar el mapa si cambian

//   // 2. Guardar las coordenadas en `localStorage` cuando cambian
//   useEffect(() => {
//     if (position) {
//       localStorage.setItem("mapPosition", JSON.stringify(position)); // Guardar en `localStorage` cada vez que `position` cambie
//     }
//   }, [position]); // Solo se ejecuta cuando la posición cambia

//   // 3. Manejo de carga y error de la API
//   if (loadError) {
//     return <div>Error al cargar el mapa</div>;
//   }

//   if (!isLoaded || position === null) {
//     return <div>Cargando mapa...</div>; // Esperar hasta que se cargue el mapa y la posición esté lista
//   }

//   // Manejamos cuando el mapa está completamente cargado
//   const onMapLoad = (map) => {
//     mapRef.current = map;
//     setMapLoaded(true); // Cuando el mapa se haya cargado, actualizamos el estado
//     mapRef.current.panTo(position); // Aseguramos que el mapa se centre en la posición
//     console.log("Mapa cargado y centrado en:", position);
//   };

//   return (
//     <GoogleMap
//       mapContainerStyle={{ width: "100%", height: "700px" }}
//       center={position} // Establece el centro en la posición
//       zoom={17} // Aumentamos el zoom para acercarnos más
//       onLoad={onMapLoad}
//     >
//       {/* Renderizar el marcador cuando el mapa está cargado */}
//       {mapLoaded && (
//         <Marker
//           position={position}
//           key={`marker-${position.lat},${position.lng}`} // Key único para el marcador
//           icon={{
//             path: window.google.maps.SymbolPath.CIRCLE,
//             scale: 17,
//             fillColor: "red",
//             fillOpacity: 1,
//             strokeColor: "white",
//             strokeWeight: 3,
//           }}
//           label="Aquí no "
//           onLoad={() => console.log("Marcador cargado en:", position)}
//         />
//       )}
//     </GoogleMap>
//   );
// };

// export default MapComponent;




// import React, { useState, useEffect, useRef } from "react";
// import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

// const MapComponent = ({ lat, lng }) => {
//   const [position, setPosition] = useState({ lat, lng });
//   const [mapLoaded, setMapLoaded] = useState(false);
//   const mapRef = useRef();

//   // Carga de la API de Google Maps
//   const { isLoaded, loadError } = useJsApiLoader({
//     googleMapsApiKey: "AIzaSyC8ecA7hFLV7REGMXlzLiZOF8XmkzNWhzY", // Asegúrate de que esta clave sea válida
//   });

//   // Mantener la posición cuando se refresca la página
//   useEffect(() => {
//     const savedPosition = localStorage.getItem("mapPosition");
//     if (savedPosition) {
//       const parsedPosition = JSON.parse(savedPosition);
//       setPosition(parsedPosition);
//     } else {
//       setPosition({ lat, lng });
//     }
//   }, []); // Solo se ejecuta una vez al cargar el componente

//   // Guardar las nuevas coordenadas en localStorage cada vez que cambian
//   useEffect(() => {
//     if (position) {
//       localStorage.setItem("mapPosition", JSON.stringify(position));
//     }
//   }, [position]);

//   // Actualizar la posición si cambian las props (coordenadas)
//   useEffect(() => {
//     if (lat && lng) {
//       setPosition({ lat, lng });
//     }
//   }, [lat, lng]);

//   // Manejo de carga y error de la API
//   if (loadError) {
//     return <div>Error al cargar el mapa</div>;
//   }

//   if (!isLoaded) {
//     return <div>Cargando mapa...</div>;
//   }

//   // Manejamos cuando el mapa está completamente cargado
//   const onMapLoad = (map) => {
//     mapRef.current = map;
//     setMapLoaded(true); // Cuando el mapa se haya cargado, actualizamos el estado
//     mapRef.current.panTo(position); // Aseguramos que el mapa se centre en la posición
//     console.log("Mapa cargado y centrado en:", position);
//   };

//   return (
//     <GoogleMap
//       mapContainerStyle={{ width: "100%", height: "700px" }}
//       center={position} // Establece el centro en la posición
//       zoom={17} // Aumentamos el zoom para acercarnos más
//       onLoad={onMapLoad}
//     >
//       {/* Solo renderizamos el marcador con el icono estándar */}
//       {mapLoaded && (
//         <Marker
//           position={position}
//           key={`standardMarker-${position.lat},${position.lng}`} // Key único para el marcador
//           icon={{
//             url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png", // Icono rojo básico de Google Maps
//             scaledSize: new window.google.maps.Size(40, 40), // Escalamos el icono si es necesario
//           }}
//           label="Marcador"
//         />
//       )}
//     </GoogleMap>
//   );
// };

// export default MapComponent;
